import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function AdminRoute({ component: C, appProps, ...rest }) {
  
  function realAdmin() {
    if (appProps.isAuthenticated && appProps.isAdmin) {
      return true
    } else {
      return false
    }
  }
  return (
    <Route
      {...rest}
      render={props =>
        realAdmin()
          ? <C {...props} {...appProps} />
          : <Redirect
              to={`/`}
            />}
    />
  );
}
